import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { Z_INDEX_TOP } from '../../../../../../define/consts/style';
import { propArrayShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import Tooltip from '../../../../Tooltip/Tooltip';
/**
 * 共有されたスライドの開封状況を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchShareItemStatus = (props) => {
    const { className, members: rawMembers } = props;
    const unreadMembers = useMemo(() => rawMembers.filter((v) => !v.readAt), [rawMembers]);
    const hasUnread = unreadMembers.length > 0;
    return (_jsx("div", Object.assign({ className: clsx('slide_search_share_item_status', className, hasUnread && 'unread') }, { children: _jsx("div", Object.assign({ className: 'status_inner' }, { children: hasUnread ? (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'status_left' }, { children: "\u672A\u958B\u5C01" })), _jsxs("span", Object.assign({ className: 'status_right' }, { children: [_jsx(Tooltip, Object.assign({ arrow: false, html: _jsx("ul", { children: unreadMembers.map((v) => (_jsx("li", Object.assign({ className: 'text-liststyle is-dot' }, { children: v.lastName && v.firstName
                                            ? `${v.lastName} ${v.firstName}`
                                            : v.email }), v.id))) }), position: 'left', zIndex: Z_INDEX_TOP }, { children: _jsx("span", Object.assign({ className: 'right_number' }, { children: unreadMembers.length })) })), "\u4EBA"] }))] })) : (_jsx("span", { children: "\u958B\u5C01\u6E08" })) })) })));
};
SlideSearchShareItemStatus.propTypes = {
    className: propStr(),
    members: propArrayShape().isRequired,
};
SlideSearchShareItemStatus.defaultProps = {
    className: '',
};
export default SlideSearchShareItemStatus;
